module.exports = __webpack_public_path__ + "static/media/v47.6fd8d5f4.mp4";